module.exports = __webpack_public_path__ + "img/img11.d5f6f48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img11.jpg
// module id = 276
// module chunks = 0